import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {
  itemsOfContentSelector,
  activeItemNameOfContentSelector
} from "../../ducks/content";
import Product from "../Product";

function CategoryProducts({items, activeItemName}) {
  return items.map((item) => {
    const isActive = activeItemName === item.singular;
    return <Product key={item.singular} product={item} isActive={isActive} />;
  });
}

CategoryProducts.propTypes = {
  activeItemName: PropTypes.string,
  items: PropTypes.array
};

export default connect((state) => ({
  activeItemName: activeItemNameOfContentSelector(state),
  items: itemsOfContentSelector(state)
}))(CategoryProducts);
